import React, { useState, useEffect, useRef } from 'react'
import loader from '../../../../assets/img/loader.svg'
import FilterEmployees from './FilterEmployees'
import Api from '../../../../_helpers/Api'
import AddOrEditEmployee from './AddOrEditEmployee'
import EmployeesOptions from './EmployeesOptions'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { useMessagesContext } from '../../../../_providers/Messages'
import { trans } from '../../../../_providers/Translation'
import NoDataFound from '../../../partials/NoDataFound'
import Error from '../../../modals/messages/Error'
import Question from '../../../modals/messages/Question'
import EmployeeFreeDays from './EmployeeFreeDays'
import '@/assets/scss/pages/settings.scss'
import { useHistory, useLocation } from 'react-router'
import axios from 'axios'

let timeout

function Employees(props) {
    const history = useHistory()
    const location = useLocation()

    const auth = useAuthDataContext()
    const messages = useMessagesContext()

    const partnerId = props.id

    const modalAddOrEditRef = useRef(null)
    const errorModalRef = useRef(null)
    const deleteModalRef = useRef(null)
    const freeDaysModalRef = useRef(null)
    const searchTimeoutRef = useRef(null)

    const searchParams = new URLSearchParams(location.search)
    const cancelTokenRef = useRef(null)

    const [employees, setEmployees] = useState({
        loading: true,
        data: [],
        update: false,
        filters: {
            name: '',
            role_id: '',
            is_active: "1"
        },
        setFilter: false
    })

    const [roles, setRoles] = useState([])

    useEffect(() => {
        setEmployees(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                name: searchParams.get('name') || '',
                role_id: searchParams.get('role_id') || '',
                is_active: searchParams.get('is_active') || "1"
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    useEffect(() => {
        if (employees.setFilter) {
            searchParams.set('page', employees.page)

            Object.entries(employees.filters).map(filter => {
                searchParams.set(filter[0], filter[1])
            })

            history.push('?' + searchParams.toString())
        }
    }, [employees.setFilter])

    useEffect(() => {
        if (employees.update) {
            loadEmployees()
        }
    }, [employees.update])

    useEffect(() => {
        loadRoles()
    }, [])

    const loadEmployees = () => {
        // Cancel previous request if running
        if (cancelTokenRef.current) {
            cancelTokenRef.current.cancel('Operation canceled due to new request.')
        }
        cancelTokenRef.current = axios.CancelToken.source()

        setEmployees(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'partners/employees/all?partner_id=' + partnerId
            + '&name=' + employees.filters.name
            + '&role_id=' + employees.filters.role_id
            + '&is_active=' + employees.filters.is_active
            + '&internal_only=1'

        Api.get(url, { cancelToken: cancelTokenRef.current.token })
            .then(res => {
                setEmployees(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }))
            }).catch(err => {
                setEmployees(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const loadRoles = () => {
        Api.get('partners/employees/roles')
            .then(res => {
                setRoles(res.data)
            })
    }

    const handleAdd = () => {

        if (props.partner) {
            if (props.partner.active_employees_count >= props.partner.max_employees) {
                return errorModalRef.current.open()
            }
        }

        modalAddOrEditRef.current.add()
    }

    const handleCreate = partner => {

        // let data = partners.data.concat(partner);

        // setPartners(prev => ({
        //     ...prev,
        //     data: data
        // }));

        setEmployees(prev => ({
            ...prev,
            update: Math.random().toString()
        }))

        if (typeof props.handleRefresh === 'function') {
            props.handleRefresh()
        }
    }

    // update
    const handleEdit = id => {
        modalAddOrEditRef.current.edit(id)
    }

    const handleUpdate = employee => {

        loadEmployees()

        if (typeof props.handleRefresh === 'function') {
            props.handleRefresh()
        }
    }

    // delete
    const handleDelete = id => {
        let modal = deleteModalRef.current

        modal.open()
        modal.onSuccess(() => {
            handleDestroy(id)
        })
    }

    const handleDestroy = id => {
        Api.post('partners/employees/remove', {
            id: id
        }).then(res => {
            if (res.data.success) {
                // let data = employees.data.filter(i => {
                //     return i.id !== id;
                // });
                // setEmployees(prev => ({
                //     ...prev,
                //     data: data
                // }));

                if (typeof props.handleRefresh === 'function') {
                    props.handleRefresh()
                }
            }
        })
    }

    const handleOpenChat = id => {

        let user = employees.data.filter(i => {
            return i.id === id
        })[0]

        messages.openChat({
            id: user.id,
            type: user.type,
            name: user.name,
            lastname: user.lastname,
            avatar: user.avatar,
            tenant_id: user.tenant_id,
            receiver_tenant_id: user.tenant_id, // ensure receiver_tenant_id is set
        })
    }

    const handleShowFreeDays = id => {
        freeDaysModalRef.current.show(id)
    }

    function handleSearch(name, value) {
        clearTimeout(searchTimeoutRef.current)

        setEmployees(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                [name]: value
            },
        }))

        searchTimeoutRef.current = setTimeout(() => {
            setEmployees(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }

    const handleRefresh = () => {
        setEmployees(prev => ({
            ...prev,
            update: Math.random().toString()
        }))
    }

    return (

        <div className='pannel'>

            <Error
                ref={errorModalRef}
                mainMessage={trans('messages.maxEmployeesReached')}
            />

            <Question
                ref={deleteModalRef}
                mainMessage={trans('headings.confirmDelete')}
            />

            <AddOrEditEmployee
                ref={modalAddOrEditRef}
                partnerId={partnerId}
                roles={roles}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
            />

            <EmployeeFreeDays
                ref={freeDaysModalRef}
            />

            <div
                className="top-part"
                style={{
                    marginBottom: 0
                }}
            >
                <div className="left">
                    <FilterEmployees
                        roles={roles}
                        handleSearch={handleSearch}
                        filters={employees.filters}
                    />
                </div>
                <div className="right">
                    {(auth.isManager()) &&
                        <button className="button button-add button-small" onClick={handleAdd}>
                            {trans('buttons.add')}
                        </button>
                    }
                </div>
            </div>
            <hr />

            {employees.loading
                ?
                <img src={loader} alt="loading" />
                :
                employees.data.length === 0
                    ?
                    <NoDataFound />
                    :
                    <ul className='settings-employees-list'>
                        {employees.data.map(e => (
                            <li
                                key={'e' + e.id}
                                className='settings-employees-list-item'
                                style={{
                                    opacity: !e.active ? 0.6 : 1
                                }}
                            >
                                <picture>
                                    <img src={e.avatar} alt='' width={40} height={40} style={{ objectFit: 'cover' }} />
                                </picture>
                                <b>
                                    {e.name} {e.lastname}
                                </b>
                                <p>
                                    {e.role ? e.role.translation.name : ''}
                                </p>
                                <a href={`tel:${e.phone_formatted}`}>
                                    {e.phone_formatted}
                                </a>
                                <div className='employee-options'>
                                    <EmployeesOptions
                                        id={e.id}
                                        handleEdit={handleEdit}
                                        handleOpenChat={handleOpenChat}
                                        handleDelete={handleDelete}
                                        handleShowFreeDays={handleShowFreeDays}
                                    />
                                </div>
                                {!e.active ?
                                    <p
                                        style={{
                                            marginBottom: 0,
                                            marginTop: "5px",
                                            color: "#615E83"
                                        }}
                                    >
                                        {trans('labels.inactive')}
                                    </p>
                                    :
                                    <>
                                    </>
                                }
                            </li>
                        )
                        )}
                    </ul>
            }
        </div>

    )
}

export default Employees